import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Select} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useCreateCryptoPayment, useSubscriptionRenewal} from "../../../api/payments";

const ButtonContainer = styled.div``;
const CryptoAddress = styled.div``;

const coinMap = {
    "Bitcoin": "btc",
    "Ethereum": "eth",
    "Dogecoin": "doge",
    "Litecoin": "ltc",
    "Tether": "usdt",
    "USD Coin": "usdc",
    "Bitcoin Cash": "bch"
};

const ProCryptoPaymentSheet = styled(({className, type, tier = 0, length = 0, awards = 0, renew, subscriptionPrice, onClose}) => {

    const [cryptocurrency, setCryptocurrency] = useState("");
    const {error, feedbackCh} = useFeedback();
    const cryptoPayment = renew ? useSubscriptionRenewal(feedbackCh) :
        useCreateCryptoPayment(feedbackCh, type, tier, length, awards, subscriptionPrice);
    const id = cryptoPayment?.id;
    const formattedCoin = cryptocurrency.replaceAll(" ", "").toLowerCase();

        return (
            <div className={className}>

                <Header>
                    <Title>Send Payment</Title>
                </Header>

                {cryptocurrency === '' ?
                    <>
                        <p>
                            Select which cryptocurrency you'd like to use to make your payment.
                        </p>
                        <div>
                            <Select style={{margin: '12px 0'}} placeholder='Select cryptocurrency'
                                    onChange={(e) => setCryptocurrency(e.currentTarget.value)}>
                                <option value='Bitcoin'>Bitcoin (BTC)</option>
                                <option value='Ethereum'>Ethereum (ETH)</option>
                                <option value='Dogecoin'>Dogecoin (DOGE)</option>
                                <option value='Litecoin'>Litecoin (LTC)</option>
                                <option value='Tether'>Tether (USDT)</option>
                                <option value='USD Coin'>USD Coin (USDC)</option>
                                <option value='Bitcoin Cash'>Bitcoin Cash (BCH)</option>
                            </Select>
                        </div>
                    </>
                    :
                    <>
                        <p>Please send your payment promptly to avoid delays.</p>
                        <p style={{fontWeight: 500, fontSize: 15, marginTop: 16}}>{coinMap[cryptocurrency].toUpperCase()} Address</p>
                        <CryptoAddress>
                            <input type={"text"} readonly value={cryptoPayment?.cryptocurrencies[formattedCoin].address} />
                        </CryptoAddress>
                        <p style={{fontWeight: 500, fontSize: 15, marginTop: 12}}>Total Amount</p>
                        <p>{cryptoPayment?.cryptocurrencies[formattedCoin].price} {coinMap[cryptocurrency].toUpperCase()} + network fees</p>
                        <p style={{fontWeight: 500, fontSize: 15, marginTop: 12}}>Payment Status</p>
                        <p>Checking for payment...</p>
                        <p style={{fontSize: 15, marginTop: 16, marginBottom: 16}}>You can safely close this window at any time. We'll continue to monitor for a payment.</p>
                    </>
                }

                <ButtonContainer>
                    <Button variant={"blue"} w={"100%"} onClick={onClose} disabled={cryptocurrency === ""}>Done</Button>
                </ButtonContainer>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
  }
`;

export default ProCryptoPaymentSheet;
